(function ($, Drupal) {

  // Selecting first word in Heading
  Drupal.behaviors.firstword = {
    attach: function (context, settings) {

      // First word in title
    	$('.page-node-301 .card__text h2').html(function(){
    		var text = $(this).text().split(' ');
    		var first = text.shift();
    		return (text.length > 0 ? '<span class="first">'+first+'</span> ' : first) + text.join(" ");
    	});
      
    }
  };

})(jQuery, Drupal);
